import {useMutation} from '@tanstack/react-query';
import type {
  BaseProjectResponse,
  CreateDraftProjectParams,
} from '@contentlab/api/project/types';
import projectUpdaters from '@contentlab/api/project/updaters';

interface UseCreateDraftProjectOptions {
  onSuccess?: (
    data: BaseProjectResponse,
    requestParams: CreateDraftProjectParams
  ) => Promise<void>;
  onError?: (error: Error) => void;
}

function useCreateDraftProject(options: UseCreateDraftProjectOptions = {}) {
  const {onSuccess, onError} = options;

  return useMutation<BaseProjectResponse, Error, CreateDraftProjectParams>({
    mutationFn: projectUpdaters.createDraftProject,
    onSuccess,
    onError,
  });
}

export default useCreateDraftProject;
